import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { Container, Button } from 'react-bootstrap';
import MainNav from '../Components/MainNav';
import Footer from '../Components/Footer';

// Set up the worker using CDN with https
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Menu = () => {
  const [activeTab, setActiveTab] = useState('menu'); // 'menu', 'sahri', 'iftar', 'iftarDinner'
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(800);

  // Tab data with images
  const tabs = {
    menu: {
      title: '📋 Menu',
      image: '/PHOTO-2026-02-26-13-13-02.jpeg',
      showPDF: true
    },
    // iftar: {
    //   title: '🍽️ Iftar + Dinner Buffet',
    //   image: '/PHOTO-2026-02-26-13-13-02.jpeg',
    //   showPDF: false
    // },
    // sahri: {
    //   title: '🌙 Sehri Buffet',
    //   image: '/PHOTO-2026-02-26-13-13-05.jpeg',
    //   showPDF: false
    // },

  };

  // Update these page numbers to match your actual PDF!
  const tableOfContents = [
    { name: 'Starters & Appetizers', page: 1, icon: '🥟' },
    { name: 'BBQ', page: 2, icon: '🍖' },
    { name: 'Soups & Salads', page: 3, icon: '🥗' },
    { name: 'Main Course - Chicken', page: 4, icon: '🍗' },
    { name: 'Main Course - Mutton', page: 5, icon: '🍖' },
    { name: 'Main Course - Beef', page: 6, icon: '🥩' },
    { name: 'Seafood', page: 7, icon: '🦐' },
    { name: 'Biryani & Rice', page: 8, icon: '🍚' },
    { name: 'Breads', page: 9, icon: '🍞' },
    { name: 'Beverages', page: 10, icon: '🥤' },
    { name: 'Desserts', page: 11, icon: '🍰' },
  ];

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Get current section based on page number
  const getCurrentSection = () => {
    let currentSection = tableOfContents[0];
    for (let i = tableOfContents.length - 1; i >= 0; i--) {
      if (pageNumber >= tableOfContents[i].page) {
        currentSection = tableOfContents[i];
        break;
      }
    }
    return currentSection;
  };

  const goToPage = (page) => {
    setPageNumber(page);
  };

  const previousPage = () => {
    setPageNumber(prev => Math.max(1, prev - 1));
  };

  const nextPage = () => {
    setPageNumber(prev => Math.min(numPages || prev, prev + 1));
  };

  // Handle responsive width
  React.useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 768) {
        setPageWidth(screenWidth - 60);
      } else if (screenWidth < 1200) {
        setPageWidth(700);
      } else {
        setPageWidth(900);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const currentTab = tabs[activeTab];

  return (
    <div style={{ backgroundColor: '#fafafa', minHeight: '100vh' }}>
      <MainNav />
      <Container style={{ maxWidth: '1200px', paddingTop: '80px', paddingBottom: '60px' }}>

        {/* Menu Title */}
        <h2 style={{
          textAlign: 'center',
          marginBottom: '40px',
          color: '#c0392b',
          fontSize: '42px',
          fontWeight: 'bold'
        }}>
          Menu
        </h2>

        {/* Tabs Navigation */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '15px',
          marginBottom: '40px',
          flexWrap: 'wrap'
        }}>
          {Object.entries(tabs).map(([key, tab]) => (
            <button
              key={key}
              onClick={() => {
                setActiveTab(key);
                setPageNumber(1); // Reset to first page when switching tabs
              }}
              style={{
                padding: '14px 30px',
                fontSize: '16px',
                fontWeight: 'bold',
                border: 'none',
                borderRadius: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: activeTab === key ? '#c0392b' : '#e8e8e8',
                color: activeTab === key ? 'white' : '#333',
                boxShadow: activeTab === key ? '0 6px 20px rgba(192, 57, 43, 0.35)' : 'none',
                transform: activeTab === key ? 'scale(1.05)' : 'scale(1)'
              }}
            >
              {tab.title}
            </button>
          ))}
        </div>

        {/* Content Section */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0 6px 30px rgba(0,0,0,0.1)',
          border: '1px solid #e8e8e8'
        }}>

          {/* Image Display - Only show for non-Menu tabs */}
          {/* {activeTab !== 'menu' && (
            <div style={{
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              borderRadius: '12px',
              overflow: 'hidden',
              border: '1px solid #ddd',
              marginBottom: '30px',
              maxWidth: '900px',
              width: '100%'
            }}>
              <img
                src={currentTab.image}
                alt={currentTab.title}
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block'
                }}
              />
            </div>
          )} */}

          {/* PDF Viewer - Only show for Menu tab */}
          {currentTab.showPDF && (
            <>
              <Document
                file="/menu.pdf"
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(error) => console.error('PDF load error:', error)}
                loading={
                  <div style={{
                    padding: '100px 60px',
                    fontSize: '20px',
                    color: '#c0392b',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '25px'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      border: '5px solid #f3f3f3',
                      borderTop: '5px solid #c0392b',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    <span style={{ fontWeight: '600' }}>Loading your menu...</span>
                  </div>
                }
                error={
                  <div style={{
                    padding: '100px 60px',
                    fontSize: '20px',
                    color: '#c0392b',
                    textAlign: 'center',
                    backgroundColor: '#fff5f5',
                    borderRadius: '16px',
                    border: '2px dashed #c0392b'
                  }}>
                    <div style={{ fontSize: '64px', marginBottom: '25px' }}>📄</div>
                    <div style={{ fontWeight: 'bold', fontSize: '24px', marginBottom: '12px' }}>
                      Failed to load PDF
                    </div>
                    <small style={{ fontSize: '16px', opacity: 0.8 }}>
                      Please check browser console for details
                    </small>
                  </div>
                }
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '30px',
                  marginBottom: '30px'
                }}>
                  {/* Left Arrow Button */}
                  <Button
                    onClick={previousPage}
                    disabled={pageNumber <= 1}
                    style={{
                      backgroundColor: pageNumber <= 1 ? '#e0e0e0' : '#c0392b',
                      color: pageNumber <= 1 ? '#999' : 'white',
                      border: 'none',
                      padding: '16px 20px',
                      fontWeight: 'bold',
                      borderRadius: '50%',
                      cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease',
                      fontSize: '24px',
                      width: '60px',
                      height: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: pageNumber <= 1 ? 'none' : '0 4px 15px rgba(192, 57, 43, 0.35)',
                    }}
                  >
                    ←
                  </Button>

                  {/* PDF Page */}
                  <div style={{
                    boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '1px solid #ddd'
                  }}>
                    <Page
                      pageNumber={pageNumber}
                      width={pageWidth}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </div>

                  {/* Right Arrow Button */}
                  <Button
                    onClick={nextPage}
                    disabled={pageNumber >= numPages}
                    style={{
                      backgroundColor: pageNumber >= numPages ? '#e0e0e0' : '#c0392b',
                      color: pageNumber >= numPages ? '#999' : 'white',
                      border: 'none',
                      padding: '16px 20px',
                      fontWeight: 'bold',
                      borderRadius: '50%',
                      cursor: pageNumber >= numPages ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease',
                      fontSize: '24px',
                      width: '60px',
                      height: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: pageNumber >= numPages ? 'none' : '0 4px 15px rgba(192, 57, 43, 0.35)',
                    }}
                  >
                    →
                  </Button>
                </div>

                {/* Page Counter */}
                <div style={{ 
                  textAlign: 'center',
                  fontSize: '18px', 
                  fontWeight: '700',
                  color: '#333',
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '25px',
                  border: '2px solid #e8e8e8',
                  maxWidth: '200px',
                  margin: '0 auto'
                }}>
                  Page <span style={{ color: '#c0392b', fontSize: '20px' }}>{pageNumber}</span> / {numPages || '--'}
                </div>
              </Document>
            </>
          )}

          {/* For Sahri and Iftar tabs */}
          {/* {!currentTab.showPDF && (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: '#666',
              fontSize: '18px'
            }}>
              <p>✨ Experience our special {activeTab === 'sahri' ? 'Sahri' : 'Iftar'} Buffet</p>
              <p style={{ fontSize: '14px', marginTop: '15px', color: '#999' }}>
                For more details, please contact us or visit the restaurant
              </p>
            </div>
          )} */}
        </div>
      </Container>
      <Footer />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Menu;